'use strict';

var _ = require('lodash');
var NetSpillRateChartDirective = function NetSpillRateChartDirective($filter, $timeout, Chart) {
  return {
    restrict: 'E',
    template: require('../templates/net-spill-rate-chart.html'),
    scope: {
      data: '='
    },
    link: function link($scope, element) {
      var chartElement = element.find('.chart-container');
      var rmNumberFormat = $filter('rmNumberFormat');
      var tooltipTemplate = _.template(require('../templates/net-spill-chart-tooltip-template.html'));
      var chartFormatters = {
        tooltipFormatter: function tooltipFormatter(d) {
          return tooltipTemplate({
            actNet: rmNumberFormat(d.actualRate, 'NUMBER'),
            optNet: rmNumberFormat(d.optimalRate, 'NUMBER'),
            actNetLabel: 'Act Net Spill',
            optNetLabel: 'Opt Net Spill',
            label: d.label
          });
        }
      };
      chartFormatters.tooltipFormatter.cssClass = 'net-spill-rate-chart in-modal';
      var chart = new Chart(chartElement, chartFormatters);

      //Ugly fix for IE not properly rendering the chart
      //when there is more than 12 records in the data.
      //Rendering it once on timeout fixes the problem only partially,
      //the correct size of the chart is applied on second render
      $timeout(function () {
        chart.render($scope.data);
        chart.render($scope.data);
      }, 0);
    }
  };
};
NetSpillRateChartDirective.$inject = ['$filter', '$timeout', 'NetSpillRateChart'];
module.exports = NetSpillRateChartDirective;